'use client';
import {
  CatButton,
  CatIconFileUpload,
  CatIconAdd
} from 'components/blocks-components';
import { Conditional, useBreakpoint } from 'components/pcc-components';
import { BUTTON_VARIANTS } from '@cat-ecom/pcc-components/src/constants/commonConstants';
import { useTranslations } from 'next-intl';
import { PAGE_BREAKPOINTS } from 'constants/common';

export const DragAndDropBox = ({ isDisabled, isAssociateEquipmentToSavedList }: { isDisabled: boolean, isAssociateEquipmentToSavedList: boolean }) => {
  const t = useTranslations();
  const isDesktop = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const UPLOAD_BUTTON_TEXT = isAssociateEquipmentToSavedList ? t('BROWSE') : t('REQUISITIONLIST_BTN_UPLOAD');

  return (
    <Conditional
      test={isDesktop}
      fallback={
        <>
          <CatIconAdd />
          {UPLOAD_BUTTON_TEXT}
        </>
      }
    >
      <>
        <CatIconFileUpload />
        <span> {t('DRAG_&_DROP_HERE')} </span>
        <CatButton disabled={isDisabled} variant={BUTTON_VARIANTS.CONTRAST}>
          {UPLOAD_BUTTON_TEXT}
        </CatButton>
      </>
    </Conditional>
  );
};
